module.exports = __webpack_public_path__ + "static/media/WhiteLogo.792f69c4.svg";